<template>
  <div id="bar-chart" class="echarts">
    <VueApexCharts
      type="rangeBar"
      :options="options"
      :series="series"
      :height="height"
    >
    </VueApexCharts>
  </div>
</template>

<script >
import VueApexCharts from "vue-apexcharts";
import { sync } from "vuex-pathify";
import apexChartsMixin from "@/../../coreui/mixins/apexChartsMixin";

export default {
  props: ["args"],
  mixins: [apexChartsMixin],
  components: {
    VueApexCharts,
  },
  watch: {
    fullScreen: {
      immediate: true,
      handler(val) {
        var self = this;
        this.options = {
          ...this.options,
          ...{
            xaxis: {
              type: "datetime",
              labels: {
                show: val ? true : false,
              },
            },
          },
        };
        setTimeout(function () {
          if (val) self.height = "98%";
          else self.height = "100%";
        }, 500);
      },
    },
  },
  args: {
    immediate: true,
    deep: true,
    handler(val, old) {
      this.series = val.values;
    },
  },
  data() {
    let self = this;
    return {
      height: 60,
      series: this.args.values,
      options: {
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: "50%",
            rangeBarGroupRows: true,
            dataLabels: {
              position: "bottom",
              // offsetY: "10%",
            },
          },
        },
        dataLabels: {
          enabled: true,
          enabledOnSeries: [1],
          formatter: function (val, opt) {
            return opt.w.globals.labels[opt.dataPointIndex];
          },
          position: "left",
          offsetX: 0,
        },
        fill: {
          type: "solid",
        },
        xaxis: {
          type: "datetime",
        },
        yaxis: {
          show: false,
        },
        legend: {
          // show: false,
          position: "top",
        },
        tooltip: {
          custom: function (opts) {
            return self.args.toolTipFormatter(
              opts.seriesIndex,
              opts.dataPointIndex
            );
          },
        },
      },
    };
  },
  computed: {
    dark: sync("misc/dark"),
    fullScreen: sync("misc/fullScreen"),
  },
  methods: {},
  beforeMount() {},
  mounted() {},
  created() {},
  destroyed() {},
};
</script>

<style >
.arrow_box {
  border: 2px solid;
  padding: 5px;
}
.echarts {
  width: 100%;
  height: 100%;
}
#bar-chart {
}
</style>